/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsStartGuidePage = {
  init: function ($section) {

    this.element = $section[0];
    this.videos = this.element.querySelectorAll(".GuidePage-block-video");
    this.collapsedContent = this.element.querySelectorAll("[data-collapse-content]");
    this.parentBlock = this.element.querySelectorAll(".GuidePage-block");
    this.desktopTriggerButtons = this.element.querySelectorAll("[data-expand-trigger]");

    this.delegateElement = new domDelegate.Delegate(this.element);
    this.documentDelegate = new domDelegate.Delegate(document.body);

    this.delegateElement.on('click', '[data-expand-trigger]', this.collapseContent.bind(this));
    this.delegateElement.on('click', '[data-mobile-expand-trigger]', this.mobileCollapseContent.bind(this));

    this.executed = false;

    if(window.PXUTheme.media_queries.desktop.matches) {
      this.refreshContent();
      this.layout = "desktop";
    } else {
      this.layout = "mobile";
    }

    window.addEventListener("resize", this.refreshContent.bind(this));

  },
  refreshContent: function() {
    if (window.PXUTheme.media_queries.desktop.matches) {

      //More than 1441
      if (this.layout == "desktop") return;

      this.videos.forEach(video => {
        video.currentTime = 0;
        video.play();
      });

      // this.collapsedContent.forEach(container => {
      //   container.removeAttribute("style");
      // });

      // this.parentBlock.forEach(container => {
      //   container.removeAttribute("data-desktop-expanded");
      // });
      // this.desktopTriggerButtons.forEach(container => {
      //   container.setAttribute("data-expand-trigger", true);
      // });

      this.layout = "desktop";

    } else {

      //Less than 1441
      if (this.layout == "mobile") return;

      this.videos.forEach(video => {
        video.currentTime = 0;
        video.pause();
      });

      this.layout = "mobile";
    }
  },
  collapseContent: function(event, target){
    var $this = this;
    let trigger = target;
    
    // Handle rigger button's labels and animation
    if (trigger.getAttribute("data-expand-trigger") === "true") {
      trigger.setAttribute("data-expand-trigger", false);
    } else {
      trigger.setAttribute("data-expand-trigger", true);
    }

    // Handle expand/collapse 
    let parentElement = trigger.closest(".GuidePage-block");
    let collapsedContent = parentElement.querySelector("[data-collapse-content]");
    let video = collapsedContent.querySelector("video");
    if ($(collapsedContent).is(":hidden")) {
      parentElement.setAttribute("data-desktop-expanded", "")
    } else {
      parentElement.removeAttribute("data-desktop-expanded", "")
    }
    $(collapsedContent).slideToggle("linear",()=>{
      this.videoCallback(video, collapsedContent);
    });
  },
  mobileCollapseContent: function(event, target){
    var $this = this;
    let parentBlock = target.closest(".GuidePage-block");
    
    // Remove all styles from partly hidden desktop content
    let desktopCollapsedContent = parentBlock.querySelector(".GuidePage-block-content-collapsed");
    if(desktopCollapsedContent) {
      desktopCollapsedContent.removeAttribute("style");
    }

    // Handle mobile content expand/collapse 
    let mobileFullContent = parentBlock.querySelector(".GuidePage-block-content");    
    let video = mobileFullContent.querySelector("video");
    if (target.getAttribute("data-expand") === "true") {
      $(mobileFullContent).slideDown(()=>{
        this.videoCallback(video, mobileFullContent)
      });
    } else {
      $(mobileFullContent).slideUp(()=>{
        this.videoCallback(video, mobileFullContent)
      });
    }

    // handling buttons
    parentBlock.toggleAttribute("data-expanded");

  },
  videoCallback: function(videoElement, collapsingElement) {
    if(videoElement == undefined) return;    
    if (!$(collapsingElement).is(":hidden")) {
      videoElement.play()
    } else {
      videoElement.pause();
      videoElement.currentTime = 0;
    }
  },
  unload: function ($section) {

  }
}

/******/ })()
;